/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Col, Container, Row, Button, Fade} from 'reactstrap';
import { Link } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faAtom, faLanguage, faBook, faHeart } from '@fortawesome/free-solid-svg-icons';
import SidebarLanding from './navbar/sidebar-landing';
import NavbarLanding from './navbar/navbar-landing';
import SubscriptionList from './item-list/subscription-list';

// This is the item list
class LandingPage extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });

        this.state = {
            subscriptionsData: null,
            navbarMobile: false
        };
        this.props.addTranslation(global);
    }

    componentDidMount() {
        console.log("Mounted");
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024}, ()=>{
            console.log(window.screen.width, this.state);
        });
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        let navBar = <SidebarLanding/>;
        if(this.state.navbarMobile)
            navBar = <NavbarLanding/>;
        return(
            <div>
                {navBar}
                <div className="landing-main">
                    <div className="center-container centered-text">
                        <img src={require('../img/logo-info.png')} alt="Company logo" className="landing-main-logo"/>
                        <br/>
                        <Fade>

                        <Link className="btn btn-imp font-now-bold btn-warning" to="/subscription-steps">
                            <Translate id="landing-page.subscribe-now"/>
                        </Link>
                            </Fade>
                    </div>
                </div>

                <div className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.main" options={{renderInnerHtml: true}}/>
                                </h1>
                            </Col>
                            <Col lg={{size:4}} md={{size:4}} sm={{size:12}} xs={{size:12}}>
                                <p>
                                    <Translate id="landing-page.main-subtitle" options={{renderInnerHtml: true}}/>
                                </p>
                            </Col>
                            <Col lg={{size:8}} md={{size:8}} sm={{size:12}} xs={{size:12}}>
                                <video className="img-fluid" src={require('../vid/video.mp4')} controls>
                                    Your browser does not support the video tag.
                                </video>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.subscriptions-for-price"/>
                                </h1>
                            </Col>
                        </Row>

                    </Container>
                    <Container className="text-center">
                        <SubscriptionList/>
                    </Container>
                </div>

                <div className="container-orange container-padding">
                    <Container>
                        <Row className="text-center text-white">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <img src={require('../img/landing-subjects.png')} className="img-fluid" alt="Landing Math"/>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.subjects"/>
                                </h1>
                                <h2 className="font-now-bold">
                                    <i><Translate id="landing-page.what-we-include"/></i>
                                </h2>
                                <hr/>
                                <h3> <FontAwesomeIcon className="fa-3x" icon={faPlusSquare} />
                                    <p/>
                                    <Translate id="landing-page.math-spanish" options={{renderInnerHtml: true}}/>
                                </h3>
                                <h3>
                                    <Translate id="landing-page.math-english" options={{renderInnerHtml: true}}/>
                                </h3>
                                <h3>
                                    <FontAwesomeIcon className="fa-3x" icon={faAtom} />
                                    <p/>
                                    <Translate id="landing-page.science-english" options={{renderInnerHtml: true}}/>
                                </h3>
                                <h3> <FontAwesomeIcon className="fa-3x" icon={faLanguage} />
                                    <p/>
                                    <Translate id="landing-page.spanish" options={{renderInnerHtml: true}}/>
                                </h3>
                                <h3>
                                    <FontAwesomeIcon className="fa-2x" icon={faBook} />
                                    <p/>
                                    <Translate id="landing-page.english" options={{renderInnerHtml: true}}/>
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.curriculum" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <h2><Translate id="landing-page.curriculum-1" options={{renderInnerHtml: true}}/> </h2>
                                <h2><Translate id="landing-page.curriculum-2" options={{renderInnerHtml: true}}/></h2>
                                <h2><Translate id="landing-page.curriculum-3" options={{renderInnerHtml: true}}/> <FontAwesomeIcon className="fa-2x" icon={faHeart} />.</h2>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-blue container-padding white-text">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.activities" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <img src={require('../img/landing-activities.png')} className="img-fluid" alt="Landing Math"/>
                                <h2>
                                    <Translate id="landing-page.activities-1" options={{renderInnerHtml: true}}/>
                                </h2>
                                <h2>
                                    <Translate id="landing-page.activities-2" options={{renderInnerHtml: true}}/>
                                </h2>
                                <h2>
                                    <Translate id="landing-page.activities-3" options={{renderInnerHtml: true}}/>
                                </h2>
                                <h2>
                                    <Translate id="landing-page.activities-4" options={{renderInnerHtml: true}}/>
                                </h2>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.track-progress" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <img src={require('../img/landing-results.png')} className="img-fluid" alt="Landing Math"/>
                                <h2>
                                    <Translate id="landing-page.track-progress-1" options={{renderInnerHtml: true}}/>
                                </h2>
                                <h2>
                                    <Translate id="landing-page.track-progress-2" options={{renderInnerHtml: true}}/>
                                </h2>
                                <h2><Translate id="landing-page.track-progress-3" options={{renderInnerHtml: true}}/> </h2>
                                <Link className="btn btn-imp font-now-bold btn-warning" to="/subscription-steps">
                                    <Translate id="landing-page.subscribe-now" options={{renderInnerHtml: true}}/>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="container-teal container-padding white-text">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="landing-page.are-you-subscribed" options={{renderInnerHtml: true}}/>
                                </h1>
                                <hr/>
                                <h2>
                                    <Translate id="landing-page.download" options={{renderInnerHtml: true}}/>
                                </h2>
                                <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                    <Link className="btn btn-imp font-now-bold btn-info" to="/download">
                                        <Translate id="landing-page.yes-download" options={{renderInnerHtml: true}}/>
                                    </Link>
                                </Col>
                                <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                    <Link className="btn btn-imp font-now-bold btn-warning" to="/subscription-steps">
                                        <Translate id="landing-page.no-subscribe" options={{renderInnerHtml: true}}/>
                                    </Link>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(LandingPage);


// WEBPACK FOOTER //
// ./src/components/landing-page.js